<template>
	<div class="role">

		<!-- 新增菜單 -->
		<el-button @click="addMenus()" class="add qjc-fts-16">新增根菜單</el-button>
		
		<el-table
			:data="menus"
			row-key="id"
			:tree-props="{ children: 'son' }"
		>
		
		<!-- :height="mainHeight-218+'px'" -->
			<el-table-column
				label="編號"
				prop="id"
			></el-table-column>
			
			
			
			<el-table-column
				label="菜單名稱"
				prop="name"
				min-width="180px"
			></el-table-column>
			
		
			
			<el-table-column
				label="路由"
				prop="url"
			></el-table-column>
			
			<el-table-column
				label="圖標"
			>
				<template slot-scope="scope">
					<img v-if="scope.row.icon.indexOf('.png') != -1" :src="require('@/assets/images/'+scope.row.icon)" class="icon" /> 
					<span v-else>{{ scope.row.icon }}</span>
				</template>
			</el-table-column>
			
			<el-table-column
				label="是否顯示"
			>
				
				<template slot-scope="scope">
					<span class="order_status_80" v-if="scope.row.display == 1 ">顯示</span>
					
					<span class="pay_status_1" v-else>隱藏</span>
				</template>
			</el-table-column>
			<el-table-column
				label="父節點"
				prop="pid"
			></el-table-column>
			<el-table-column
				label="排序"
				prop="sort"
			>
			</el-table-column>
			<el-table-column
				label="操作"
				min-width='180px'
				fixed="right"
			>
				<template slot-scope="scope">
					<div v-if="scope.row.pid == 0" @click="addMenus(scope.row)" class="addChildMenus" >添加子菜單</div>
					<i @click="editMenus(scope.row)" class="el-icon-edit"></i>
					<!-- <i @click="remove" class="el-icon-delete"></i> -->
				</template>
			</el-table-column>
		</el-table>
		
			<el-pagination
				@current-change="pageChange"
				:current-page.sync="pager.page"
				hide-on-single-page
				:page-size="pager.pagesize"
				prev-text="上一頁"
				next-text="下一頁"
				layout="total, prev, pager, next,jumper"
				:total="pager.count">
			</el-pagination>
		
		<!-- 新增、修改彈窗 -->
		<el-dialog
		  :title="dialogTitle"
		  :visible.sync="isAlert"
		  width="600px"
		  :close-on-click-modal="false"
		 >
			<el-form
				:model="formData"
				:rules="rules"
				hide-required-asterisk
				ref="form"
				label-width="120px"
			>
				<el-form-item
					label="菜單名稱"
					prop="name"
				
				>
					<el-input
						v-model="formData.name" :maxlength="20"
					></el-input>
				</el-form-item>
				
				
				
				<el-form-item
					label="根菜單"
					prop="pid"
					v-if="isChildMenus"
				>
					<el-select v-model="formData.pid">
						<el-option
							v-for="item in topMenus"
							:key="item.id"
							:label="item.name"
							:value="item.id"
						></el-option>
					</el-select>
				</el-form-item>
				
				<el-form-item
					label="圖標名稱"
					prop="icon"
				>
					<el-input
						v-model="formData.icon" :maxlength="20"
					></el-input>
				</el-form-item>
				
				<el-form-item
					label="路由名稱"
					prop="url"
					v-if="isChildMenus || isEditSonMenu"
				>
					<el-input
						v-model="formData.url" :maxlength="20"
					></el-input>
				</el-form-item>
				
				<el-form-item
					label="排序"
					prop="sort"
				>
					<el-input
						v-model="formData.sort" :maxlength="20"
					></el-input>
				</el-form-item>
				
				<el-form-item
					label="是否顯示"
					prop="display"
				>
					<el-radio
						v-model="formData.display"
						label="1"
					>顯示</el-radio>
					<el-radio
						v-model="formData.display"
						label="0"
					>隱藏</el-radio>
				</el-form-item>
				
			</el-form>
			
			<div  class="dialog-footer">
				<el-button class="cancel-btn" @click="formCancel">取消</el-button>
				<el-button class="submit-btn" @click="formSubmit">提交</el-button>
			</div>
		</el-dialog>
		
	</div>
</template>

<script>
	import { adminMenu } from "@/js/axios"
	
	export default{
		name: 'superAdminMenus',
		data() {
			return {
				isAlert: false,
				oper: '',
				mainHeight: (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight) - 60,
				formData: {
					name: '',
					en_name: '',
					pid: '',// 父級id 必傳 頂級目錄 0，不是則傳選中目錄id
					icon: '',
					url: '',
					sort: 100,
					display: '1'
				},
				rules: {
					name: [
						{ required: true, message: '菜單名稱不能為空', trigger: 'blur' }
					],
					en_name: [
						{ required: false, message: '英文名稱不能為空', trigger: 'blur' }
					],
					isTop: [
						{ required: true, message: '請選擇是否為一級菜單', trigger: 'change' }
					],
					pid: [
						{ required: true, message: '請選擇是否為一級菜單', trigger: 'change' }
					],
					display: [
						{ required: true, message: '是否顯示必選', trigger: 'change' }
					]
				},
				
				isTop: '',// 是否為一級菜單
				
				menus: [],
				
				topMenus: [],// 一級菜單列表
				
				pager: {
					page: 1,
					pagesize: 12,
					count: 0
				},
				dialogTitle:"操作菜單",
				isChildMenus:false,
				isEditSonMenu:false
				
			}
		},
		watch: {
			
			'formData.name':{
				handler(val){
					if(val) {
						this.formData.name = val.replace(/\s+/g,"")
					}
					
				},
				deep:true,
				immediate:true
			},
			'formData.en_name':{
				handler(val){
					if(val) {
						this.formData.en_name = val.replace(/\s+/g,"")
					}
					
				},
				deep:true,
				immediate:true
			},
			'formData.icon':{
				handler(val){
					if(val) {
						this.formData.icon = val.replace(/\s+/g,"")
					}
					
				},
				deep:true,
				immediate:true
			},
			'formData.url':{
				handler(val){
					if(val) {
						this.formData.url = val.replace(/\s+/g,"")
					}
					
				},
				deep:true,
				immediate:true
			},
			'formData.sort':{
				handler(val){
					if(val && typeof val == 'string') {
						this.formData.sort = val.replace(/(\s|[^\d])+/g,"")
					}
					
				},
				deep:true,
				immediate:true
			},
		},
		mounted() {
			this.$nextTick(() => {
				this.getList();
			});
		},
		methods: {
			
			getTopMenus(){
				const data = {
					act:"topMenu"
				}
				adminMenu(data).then(res => {
					if(res.code == 200){
						let result = JSON.parse(window.atob(res.data))
						this.topMenus = result;
					}else{
						this.$myAlert({
							type: 'fail',
							title: res.msg
						});
					}
				});
			},
			// 獲取列表
			getList() {
				adminMenu(this.pager).then(res => {
					if(res.code == 200){
						let result = JSON.parse(window.atob(res.data))
						this.menus = result.data;
						this.pager = result.pager;
						
						// 數值可能為字符串，需轉換為number
						for(var key in this.pager){
							this.pager[key] = parseInt(this.pager[key]);
						}
					}else{
						this.$myAlert({
							type: 'fail',
							title: res.msg
						});
					}
				});
			},
			
			pageChange(page) {
				this.pager.page = page;
				this.getList();
			},
			
			// 參數：修改(edit)或添加(add)
			showDialog(oper, id) {
				this.oper = oper;
				this.isAlert = true;
				
				if(oper == 'add'){
					this.dialogTitle = `增加根菜單`
					if(this.formData.pid || this.formData.name){
						this.$refs.form.resetFields();// 重置表單
					}
				}else if(oper == 'edit'){
					adminMenu({
						act: 'query',
						id: id
					}).then(res => {
						if(res.code == 200){
							let result = JSON.parse(window.atob(res.data))
							this.formData = result;
							
							if(this.formData.pid == 0){
								this.isTop = '1';
							}else{
								this.isTop = '0';
							}
						}else{
							this.$myAlert({
								type: 'fail',
								title: res.msg
							});
						}
					});
				}
				
			},
			addMenus(row = {}){
				this.oper = 'add'
				this.formData.id = undefined
				
				this.formData = {
					sort:100
				}
				
				if(row.pid && row.pid === '0'){
					this.isEditSonMenu = true
				}else{
					this.isEditSonMenu = false
				}
				
				if(row.id){
					this.getTopMenus()
					this.formData.pid = row.id
					this.dialogTitle = `新增子菜單`
					this.isChildMenus = false
				}else{
					this.formData.pid = 0
					this.dialogTitle = `新增根菜單`
					this.isChildMenus = false
				}
				this.isAlert = true;
			},
			editMenus({id,pid},title){
				if(!id) return 
				if(pid != '0'){
					this.isChildMenus = true
				}else{
					this.isChildMenus = false
				}
				this.dialogTitle = title || `修改菜單`
				adminMenu({
					act: 'detail',
					id: id
				}).then(res => {
					if(res.code == 200){
						let result = JSON.parse(window.atob(res.data))
						this.formData = result;
						this.oper = 'edit'
						if(this.formData.pid && this.formData.pid != 0){
							this.isChildMenus = true
						}
						this.isAlert = true;
						this.getTopMenus()
					}else{
						this.$myAlert({
							type: 'fail',
							title: res.msg
						});
					}
				});
			},
			
			menuChange(key, data) {
				this.formData.menus = data.checkedKeys;
			},
			
			formCancel() {
				this.isAlert = false;
				this.$refs.form.resetFields();// 重置表單
			},
			
			formSubmit() {
				const acts = ['update','add','addSon','updateSon']
				this.$refs.form.validate(isSuc => {
					if(isSuc){
						const data = JSON.parse(JSON.stringify(this.formData))
						if(data.id){
							if (data.pid == 0) {
								data.act = 'update'
							} else{
								data.act = 'updateSon'
							}
						}else{
							if (data.pid == 0) {
								data.act = 'add'
							} else{
								data.act = 'addSon'
							}
						}
						
						
						adminMenu(data).then(res => {
							if(res.code == 200){
								this.isAlert = false;
								this.getList();
								
								this.$myAlert({
									type: 'success',
									title: (this.oper == 'add'?'添加':'修改')+'成功'
								});
							}else{
								this.$myAlert({
									type: 'fail',
									title: res.msg
								});
							}
						});
					}
				});
			},
			
			remove() {
				this.$myAlert({
					title: '確定刪除？',
					callback: () => {// 點擊確認觸發
						console.log('delete')
					}
				});
			}
		}
	}
</script>

<style scoped>
	.el-dialog .el-form >>> .el-form-item__label{
		text-align: right;
	}
	.el-dialog .el-form >>> .el-form-item__content{
		
	}
	
	.role >>>  .cell{
		white-space: nowrap !important;
	}
	
	.role>>>.el-button:active {
		color: #fff !important;
		border: none;
		background-color: #6883FB !important;
	}
	
	.role>>>.el-button--default:focus {
		color: #fff !important;
		border: none;
		background-color: #6883FB !important;
	}
	
	
</style>
<style lang="scss" scoped>
	.role{
		position: relative;
		width: 100%;
		height: 100%;
		padding: 28px 24px;
		padding-top: 0;
		
		.add{
			padding: 8px 12px;
			margin: 24px 0 12px;
			color: #fff;
		}
		
		.el-table{
			i[class^=el-icon]{
				margin-right: 16px;
				cursor: pointer;
			}
			.icon{
				width: 24px;
				height: auto;
			}
			
			.cell{
				white-space: nowrap !important;
			}
		}
		
		.foot-pagination {
			// position: absolute;
			// bottom: 0;
			width: 96%;
			// height: 80px;
		}
		
		
		.el-dialog{
			.dialog-footer{
				display: flex;
				align-items: center;
				justify-content: center;
				
				.cancel-btn {
					width: 94px;
					height: 34px;
					font-size: 14px;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 500;
					color: #6883FB;
					border: 1px solid #6883FB;
					border-radius: 17px;
					background-color: #fff;
				}
				.submit-btn {
					width: 94px;
					height: 34px;
					font-size: 14px;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 500;
					color: #fff;
					border: none;
					border-radius: 17px;
					background-color: #6883FB;
					margin-left: 16px;
				}
				.el-button{
					font-size: 16px;
				}
			}
		}
	}
	
	.addChildMenus{
		margin-right: 12px;
		color: #6883FB;
		float: left;
		cursor: pointer;
	}
	
</style>
